/**
 * @generated SignedSource<<51999d3a39b96c7b8e56f2294ff5df93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteHydrantFamilyInput = {
  hydrantFamilyId: string;
  clientMutationId?: string | null;
};
export type HydrantFamiliesTableDeleteHydrantFamilyMutation$variables = {
  input: DeleteHydrantFamilyInput;
};
export type HydrantFamiliesTableDeleteHydrantFamilyMutationVariables = HydrantFamiliesTableDeleteHydrantFamilyMutation$variables;
export type HydrantFamiliesTableDeleteHydrantFamilyMutation$data = {
  readonly deleteHydrantFamily: {
    readonly hydrantFamily: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type HydrantFamiliesTableDeleteHydrantFamilyMutationResponse = HydrantFamiliesTableDeleteHydrantFamilyMutation$data;
export type HydrantFamiliesTableDeleteHydrantFamilyMutation = {
  variables: HydrantFamiliesTableDeleteHydrantFamilyMutationVariables;
  response: HydrantFamiliesTableDeleteHydrantFamilyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHydrantFamilyPayload",
    "kind": "LinkedField",
    "name": "deleteHydrantFamily",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantFamily",
        "kind": "LinkedField",
        "name": "hydrantFamily",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HydrantFamiliesTableDeleteHydrantFamilyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HydrantFamiliesTableDeleteHydrantFamilyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6fe4a38c47496fdac6c592e4bd3c7cd1",
    "id": null,
    "metadata": {},
    "name": "HydrantFamiliesTableDeleteHydrantFamilyMutation",
    "operationKind": "mutation",
    "text": "mutation HydrantFamiliesTableDeleteHydrantFamilyMutation(\n  $input: DeleteHydrantFamilyInput!\n) {\n  deleteHydrantFamily(input: $input) {\n    hydrantFamily {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a5ba24b52d76dc51d9f4ff6fbd0c7d7";

export default node;
